export default __webpack_public_path__ + "images/c77dfe0c51881305bd2ad97e1973f611.jpeg";